import React, { useState, useEffect } from "react";
import { ArrowDownIcon } from "../assets/icons";
import { getFullReport, getOzet, getSummary, getVisitReport, getWasteReport, getVisitedReport, getSoforReport, getHakedisReport } from "../services/summaryService";
import { formatNumber } from "../helpers/stringHelpers";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LabelList } from "recharts"; 
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import useModalClose from "../hooks/useModalClose";
import { getAllNeighborhoods } from "../services/addressService";

const Summary = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [summaryData, setSummaryData] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [globalFilter, setGlobalFilter] = useState("");
  const [loading, setLoading] = useState(true);

  // Raporlar için
  const [showReportContainer, setShowReportContainer] = useState(false);
  const [isAllReportLoading, setIsAllReportLoading] = useState(false);
  const [isVisitReportLoading, setIsVisitReportLoading] = useState(false);
  const [isVisitReportLoading2, setIsVisitReportLoading2] = useState(false);
  const [isWasteReportLoading, setIsWasteReportLoading] = useState(false);
  const [isVisitedReportLoading, setIsVisitedReportLoading] = useState(false);
  const [isVisitFilterModalOpen, setIsVisitFilterModalOpen] = useState(false);
  const [visitReportType, setVisitReportType] = useState(null);
  const [isSoforFilterModalOpen, setIsSoforFilterModalOpen] = useState(false);
  const [isSoforReportLoading, setIsSoforReportLoading] = useState(false);
  const [isHakedisFilterModalOpen, setIsHakedisFilterModalOpen] = useState(false);
  const [isHakedisReportLoading, setIsHakedisReportLoading] = useState(false);
  const [hakedisTamHafta, setHakedisTamHafta] = useState(true);
  const [neighborhoodOptions, setNeighborhoodOptions] = useState([]);
  const [streetOptions, setStreetOptions] = useState([]);
  const [isNeighborhoodLoading, setIsNeighborhoodLoading] = useState(false);
  const [isStreetLoading, setIsStreetLoading] = useState(false);
  const [selectedNeighborhoods, setSelectedNeighborhoods] = useState([]);
  const [selectedStreets, setSelectedStreets] = useState([]);
  useModalClose(showReportContainer, () => setShowReportContainer(false));

  const rows = 25;
  useEffect(() => {   
    const today = new Date().toISOString().split("T")[0];
    setStartDate(today);
    setEndDate(today);
    fetchData({ startDate: today, endDate: today });
  }, []);
  const handlePageChange = (event) => {
    setPage(event.page);
  };

  const handleFilterChange = (e) => {
    const value = e.target.value.toLowerCase();
    setGlobalFilter(value);
    const filtered = data.filter((item) => {
      return (
        item.islemTarihi?.toLowerCase().includes(value) ||
        item.islemSaati?.toLowerCase().includes(value) ||
        item.adres?.toLowerCase().includes(value) ||
        item.personel?.toLowerCase().includes(value) ||
        item.islemTuru?.toLowerCase().includes(value) ||
        item.katilmamaSebebi?.toLowerCase().includes(value)
      );
    });
    setFilteredData(filtered);
   setPage(0);
  };
  const fetchData =async ({ startDate, endDate}) => {
    try {
      setError(null);
      const data = await getSummary({ startDate, endDate});    
        setData(data.data);  
        setFilteredData(data.data);    setLoading(false)
    } catch (error) {
      console.error("Veri çekme hatası:", error);
    }
  };
  const fetchSummaryData = async ({ startDate, endDate }) => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await getOzet({ startDate, endDate });
      setSummaryData(data);
    } catch (error) {
      console.error("Failed to fetch summary data:", error);
      setError("Özet verileri alınamadı");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setStartDate(today);
    setEndDate(today);
    fetchSummaryData({ startDate: today, endDate: today });
    fetchNeighborhoods();
  // eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount
  }, []);

  const handleFilter = () => {
    if (startDate && endDate) {
      fetchSummaryData({ startDate, endDate });
    }
  };

  const fetchNeighborhoods = async () => {
    try {
      setIsNeighborhoodLoading(true);
      const response = await getAllNeighborhoods();
      
      // Response structure: { status: 200, message: "Success", data: [{id: "...", ad: "..."}] }
      const neighborhoods = response?.data?.data || response?.data || [];
      
      const normalized = neighborhoods
        .map((item) => ({
          id: String(item.id || ""),
          name: String(item.ad || ""),
        }))
        .filter((item) => item.id && item.name);
      
      setNeighborhoodOptions(normalized);
    } catch (error) {
      console.error("Failed to fetch neighborhoods:", error);
      setNeighborhoodOptions([]);
    } finally {
      setIsNeighborhoodLoading(false);
    }
  };

  const openVisitFilterModal = (type) => {
    setVisitReportType(type);
    setSelectedNeighborhoods([]);
    setIsVisitFilterModalOpen(true);
  };

  const closeVisitFilterModal = () => {
    setIsVisitFilterModalOpen(false);
    setVisitReportType(null);
    setSelectedNeighborhoods([]);
  };

  const openSoforFilterModal = () => {
    setSelectedNeighborhoods([]);
    setSelectedStreets([]);
    setStreetOptions([]);
    setIsSoforFilterModalOpen(true);
  };

  const closeSoforFilterModal = () => {
    setIsSoforFilterModalOpen(false);
    setSelectedNeighborhoods([]);
    setSelectedStreets([]);
    setStreetOptions([]);
  };

  const openHakedisFilterModal = () => {
    setSelectedNeighborhoods([]);
    setHakedisTamHafta(true);
    setIsHakedisFilterModalOpen(true);
  };

  const closeHakedisFilterModal = () => {
    setIsHakedisFilterModalOpen(false);
    setSelectedNeighborhoods([]);
  };

  useModalClose(isVisitFilterModalOpen, closeVisitFilterModal);
  useModalClose(isSoforFilterModalOpen, closeSoforFilterModal);
  useModalClose(isHakedisFilterModalOpen, closeHakedisFilterModal);

  const handleNeighborhoodSelect = (e) => {
    setSelectedNeighborhoods(e.value || []);
    if (isSoforFilterModalOpen) {
      setSelectedStreets([]);
    }
  };

  const downloadVisitReport = async ({ ilce, mah } = {}) => {
    try {
      setIsVisitReportLoading(true);
      const params = { startDate, endDate, filtrele: 0 };

      if (ilce) {
        params.ilce = ilce;
      }

      if (mah) {
        params.mah = mah;
      }

      const response = await getVisitReport(params);
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const today = new Date().toLocaleDateString("tr-TR").replace(/\./g, "-");
      link.href = url;
      link.download = `ziyaretci-raporlari-${today}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download full report:", error);
      setError("Rapor indirme işlemi başarısız oldu");
    } finally {
      setIsVisitReportLoading(false);
    }
  };

  const downloadVisitReportFiltered = async ({ ilce, mah } = {}) => {
    try {
      setIsVisitReportLoading2(true);
      const params = { startDate, endDate, filtrele: 1 };

      if (ilce) {
        params.ilce = ilce;
      }

      if (mah) {
        params.mah = mah;
      }

      const response = await getVisitReport(params);
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const today = new Date().toLocaleDateString("tr-TR").replace(/\./g, "-");
      link.href = url;
      link.download = `ziyaretci-raporlari-${today}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download full report:", error);
      setError("Rapor indirme işlemi başarısız oldu");
    } finally {
      setIsVisitReportLoading2(false);
    }
  };

  const handleVisitFilterSubmit = async (event) => {
    event.preventDefault();

    const filters = {};

    if (selectedNeighborhoods.length > 0) {
      filters.mah = selectedNeighborhoods.map((n) => n.id).join(",");
    }

    const downloadFn = visitReportType === "filtered" ? downloadVisitReportFiltered : downloadVisitReport;
    await downloadFn(filters);
    closeVisitFilterModal();
  };

  const downloadSoforReport = async ({ ilce, mahalle, sokak } = {}) => {
    try {
      setIsSoforReportLoading(true);
      const params = {
        baslangicTarihi: startDate,
        bitisTarihi: endDate,
      };

      if (ilce) params.ilce = ilce;
      if (mahalle) params.mahalle = mahalle;
      if (sokak) params.sokak = sokak;

      const response = await getSoforReport(params);
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const today = new Date().toLocaleDateString("tr-TR").replace(/\./g, "-");
      link.href = url;
      link.download = `sofor-raporlari-${today}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download Soför report:", error);
      setError("Rapor indirme işlemi başarısız oldu");
    } finally {
      setIsSoforReportLoading(false);
    }
  };

  const handleSoforFilterSubmit = async (event) => {
    event.preventDefault();

    const filters = {};

    if (selectedNeighborhoods.length > 0) {
      filters.mahalle = selectedNeighborhoods.map((n) => n.id).join(",");
    }

    if (selectedStreets.length > 0) {
      filters.sokak = selectedStreets.map((s) => s.name).join(",");
    }

    await downloadSoforReport(filters);
    closeSoforFilterModal();
  };
  const downloadHakedisReport = async ({ ilce, mah } = {}) => {
    try {
      setIsHakedisReportLoading(true);
      const params = { startDate, endDate, tamHafta: hakedisTamHafta };

      if (ilce) params.ilce = ilce;
      if (mah) params.mah = mah;

      const response = await getHakedisReport(params);
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const today = new Date().toLocaleDateString("tr-TR").replace(/\./g, "-");
      link.href = url;
      link.download = `hakedis-listesi-${today}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download Hakedis report:", error);
      setError("Rapor indirme işlemi başarısız oldu");
    } finally {
      setIsHakedisReportLoading(false);
    }
  };

  const handleHakedisFilterSubmit = async (event) => {
    event.preventDefault();

    const filters = {};

    if (selectedNeighborhoods.length > 0) {
      filters.mah = selectedNeighborhoods.map((n) => n.id).join(",");
    }

    await downloadHakedisReport(filters);
    closeHakedisFilterModal();
  };

  const handleVisitedReport = async () => {
    try {
      setIsVisitedReportLoading(true);
      const response = await getVisitedReport();
      const blob = response.data;
      // Dosya oluşturma ve indirme işlemi
      const url = window.URL.createObjectURL(blob); 
      const link = document.createElement("a");
      const today = new Date().toLocaleDateString("tr-TR").replace(/\./g, "-");
      link.href = url;
      link.download = `ziyaretraporu-${today}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download full report:", error);
      setError("Rapor indirme işlemi başarısız oldu");
    } finally {
      setIsVisitedReportLoading(false);
    }
  }
  const handleFullReport = async () => {
    try {
      setIsAllReportLoading(true);
      const response = await getFullReport( { startDate, endDate }  );
      const blob = response.data;
      // Dosya oluşturma ve indirme işlemi
      const url = window.URL.createObjectURL(blob); 
      const link = document.createElement("a");
      const today = new Date().toLocaleDateString("tr-TR").replace(/\./g, "-");
      link.href = url;
      link.download = `tam-rapor-${today}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download full report:", error);
      setError("Rapor indirme işlemi başarısız oldu");
    } finally {
      setIsAllReportLoading(false);
    }
  };

  const handleWasteReport = async () => {
    try {
      setIsWasteReportLoading(true);
      const response = await getWasteReport( { startDate, endDate }  );
      const blob = response.data;
      // Dosya oluşturma ve indirme işlemi
      const url = window.URL.createObjectURL(blob); 
      const link = document.createElement("a");
      const today = new Date().toLocaleDateString("tr-TR").replace(/\./g, "-");
      link.href = url;
      link.download = `poset-verme-alma-raporlari-${today}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download full report:", error);
      setError("Rapor indirme işlemi başarısız oldu");
    } finally {
      setIsWasteReportLoading(false);
    }
  }

  if (isLoading) {
    return (
      <div className="people-container">
        <h1 className="page-title">Özet</h1>
        <div className="loading">Yükleniyor...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="people-container">
        <h1 className="page-title">Özet</h1>
        <div className="error-message">{error}</div>
      </div>
    );
  }
 
  const topIlceler = summaryData?.ilce || [];
  const topMahalleler = summaryData?.mahalle || [];

 
  return (
    <div className="people-container neighborhood-container">
      <h1 className="page-title">Özet</h1>

      <div className="search-filter-section">
        <div className="filter-container filter-container-between summary-filter-container">
          <div className="filter-container">
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="p-inputtext p-component date-input"
              style={{ height: "43px", padding: "0 10px" }}
            />
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="p-inputtext p-component date-input"
              style={{ height: "43px", padding: "0 10px" }}
            />
            <button
              onClick={handleFilter}
              className="filter-button"
              style={{
                width: "100px",
                color: "white",
                backgroundColor: "#18964e",
                border: "0px",cursor:"pointer",
                height: "40px",
                borderRadius: "5px",
              }}
            >
              Filtrele
            </button>
          </div>
          {/* <button
            className="download-excel-button"
            onClick={handleFullReport}
            disabled={isReportLoading}
          >
            <p>{isReportLoading ? "İndiriliyor..." : "Tüm Raporlar"}</p>
            {isReportLoading ? (
              <div className="spinner"></div>
            ) : (
              <ArrowDownIcon color="white" className="filter-icon" />
            )}
          </button> */}
          <button className="download-excel-button" onClick={() => setShowReportContainer(true)}>
            <p>Raporlar</p>
            <ArrowDownIcon color='white' className="filter-icon" />
          </button>
          {showReportContainer && (
            <>
              <div className="modal-backdrop" onClick={() => { setShowReportContainer(false); closeVisitFilterModal(); closeSoforFilterModal(); closeHakedisFilterModal(); }}></div>
              <div className="report-modal-content" onClick={(e) => e.stopPropagation()}>
                {isHakedisFilterModalOpen ? (
                  <div className="visit-filter-modal-inner">
                    <h3 className="visit-filter-title">Hakediş Listesi</h3>
                    <form className="visit-filter-form" onSubmit={handleHakedisFilterSubmit}>
                      <div className="visit-filter-group mahalle-group">
                        <label htmlFor="hakedis-neighborhood-select">Mahalle</label>
                        <MultiSelect
                          id="hakedis-neighborhood-select"
                          value={selectedNeighborhoods}
                          options={neighborhoodOptions}
                          onChange={handleNeighborhoodSelect}
                          optionLabel="name"
                          placeholder="Mahalle Seçiniz"
                          className="mahalle-multiselect"
                          disabled={isNeighborhoodLoading || neighborhoodOptions.length === 0}
                          filter
                          display="chip"
                          maxSelectedLabels={3}
                          appendTo="self"
                        />
                        {isNeighborhoodLoading && <p className="modal-helper-text">Mahalleler yükleniyor...</p>}
                        {selectedNeighborhoods.length > 0 && (
                          <p className="modal-helper-text">{selectedNeighborhoods.length} mahalle seçildi.</p>
                        )}
                      </div>
                      <div className="visit-filter-group">
                        <label htmlFor="hakedis-tam-hafta" style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
                          <input
                            id="hakedis-tam-hafta"
                            type="checkbox"
                            checked={hakedisTamHafta}
                            onChange={(e) => setHakedisTamHafta(e.target.checked)}
                            style={{ cursor: "pointer" }}
                          />
                          Haftaları tamamla (Pazartesi - Pazar)
                        </label>
                        <p className="modal-helper-text">
                          {hakedisTamHafta
                            ? "Aralığın ilk ve son haftası tam hafta olarak hesaplanır."
                            : "Sayım yalnızca seçilen tarih aralığına kırpılır."}
                        </p>
                      </div>
                      <div className="visit-filter-actions">
                        <button type="button" className="visit-filter-cancel" onClick={closeHakedisFilterModal}>
                          Geri
                        </button>
                        <button
                          type="submit"
                          className="download-excel-button"
                          disabled={isHakedisReportLoading}
                        >
                          <p>{isHakedisReportLoading ? "İndiriliyor..." : "Raporu İndir"}</p>
                          {isHakedisReportLoading ? (
                            <div className="spinner"></div>
                          ) : (
                            <ArrowDownIcon color="white" className="filter-icon" />
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                ) : isSoforFilterModalOpen ? (
                  <div className="visit-filter-modal-inner">
                    <h3 className="visit-filter-title">Şoför Raporları</h3>
                    <form className="visit-filter-form" onSubmit={handleSoforFilterSubmit}>
                      <div className="visit-filter-group mahalle-group">
                        <label htmlFor="sofor-neighborhood-select">Mahalle</label>
                        <MultiSelect
                          id="sofor-neighborhood-select"
                          value={selectedNeighborhoods}
                          options={neighborhoodOptions}
                          onChange={handleNeighborhoodSelect}
                          optionLabel="name"
                          placeholder="Mahalle Seçiniz"
                          className="mahalle-multiselect"
                          disabled={isNeighborhoodLoading || neighborhoodOptions.length === 0}
                          filter
                          display="chip"
                          maxSelectedLabels={3}
                          appendTo="self"
                        />
                        {isNeighborhoodLoading && <p className="modal-helper-text">Mahalleler yükleniyor...</p>}
                        {selectedNeighborhoods.length > 0 && (
                          <p className="modal-helper-text">{selectedNeighborhoods.length} mahalle seçildi.</p>
                        )}
                      </div>
                      <div className="visit-filter-actions">
                        <button type="button" className="visit-filter-cancel" onClick={closeSoforFilterModal}>
                          Geri
                        </button>
                        <button
                          type="submit"
                          className="download-excel-button"
                          disabled={isSoforReportLoading}
                        >
                          <p>{isSoforReportLoading ? "İndiriliyor..." : "Raporu İndir"}</p>
                          {isSoforReportLoading ? (
                            <div className="spinner"></div>
                          ) : (
                            <ArrowDownIcon color="white" className="filter-icon" />
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                ) : isVisitFilterModalOpen ? (
                  <div className="visit-filter-modal-inner">
                    <h3 className="visit-filter-title">
                      {visitReportType === "filtered" ? "Ziyaret Raporları (Filtreli)" : "Ziyaret Raporları"}
                    </h3>
                    <form className="visit-filter-form" onSubmit={handleVisitFilterSubmit}>
                      <div className="visit-filter-group mahalle-group">
                        <label htmlFor="visit-neighborhood-select">Mahalle</label>
                        <MultiSelect
                          id="visit-neighborhood-select"
                          value={selectedNeighborhoods}
                          options={neighborhoodOptions}
                          onChange={handleNeighborhoodSelect}
                          optionLabel="name"
                          placeholder="Mahalle Seçiniz"
                          className="mahalle-multiselect"
                          disabled={isNeighborhoodLoading || neighborhoodOptions.length === 0}
                          filter
                          display="chip"
                          maxSelectedLabels={3}
                          appendTo="self"
                        />
                        {isNeighborhoodLoading && <p className="modal-helper-text">Mahalleler yükleniyor...</p>}
                        {selectedNeighborhoods.length > 0 && (
                          <p className="modal-helper-text">{selectedNeighborhoods.length} mahalle seçildi.</p>
                        )}
                      </div>
                      <div className="visit-filter-actions">
                        <button type="button" className="visit-filter-cancel" onClick={closeVisitFilterModal}>
                          Geri
                        </button>
                        <button
                          type="submit"
                          className="download-excel-button"
                          disabled={isVisitReportLoading || isVisitReportLoading2}
                        >
                          <p>{isVisitReportLoading || isVisitReportLoading2 ? "İndiriliyor..." : "Raporu İndir"}</p>
                          {isVisitReportLoading || isVisitReportLoading2 ? (
                            <div className="spinner"></div>
                          ) : (
                            <ArrowDownIcon color="white" className="filter-icon" />
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                ) : (
                  <>
                    <button
                      className="download-excel-button"
                      onClick={() => openVisitFilterModal("default")}
                      disabled={isVisitReportLoading}
                    >
                      <p>{isVisitReportLoading ? "İndiriliyor..." : "Ziyaret Raporları"}</p>
                      {isVisitReportLoading ? (
                        <div className="spinner"></div>
                      ) : (
                        <ArrowDownIcon color="white" className="filter-icon" />
                      )}
                    </button>
                    <button
                      className="download-excel-button"
                      onClick={openHakedisFilterModal}
                      disabled={isHakedisReportLoading}
                    >
                      <p>{isHakedisReportLoading ? "İndiriliyor..." : "Hakediş Listesi"}</p>
                      {isHakedisReportLoading ? (
                        <div className="spinner"></div>
                      ) : (
                        <ArrowDownIcon color="white" className="filter-icon" />
                      )}
                    </button>
                    <button
                      className="download-excel-button"
                      onClick={openSoforFilterModal}
                      disabled={isSoforReportLoading}
                    >
                      <p>{isSoforReportLoading ? "İndiriliyor..." : "Şoför Raporları"}</p>
                      {isSoforReportLoading ? (
                        <div className="spinner"></div>
                      ) : (
                        <ArrowDownIcon color="white" className="filter-icon" />
                      )}
                    </button>
                    <button className="download-excel-button" onClick={handleVisitedReport} disabled={isVisitedReportLoading}>
                      <p>{isVisitedReportLoading ? "İndiriliyor..." : "Görev Planı Raporları"}</p>
                      {isVisitedReportLoading ? (
                        <div className="spinner"></div>
                      ) : (
                        <ArrowDownIcon color="white" className="filter-icon" />
                      )}
                    </button>
                    <button
                      className="download-excel-button"
                      onClick={() => openVisitFilterModal("filtered")}
                      disabled={isVisitReportLoading2}
                    >
                      <p>{isVisitReportLoading2 ? "İndiriliyor..." : "Ziyaret Raporları(Filtreli)"}</p>
                      {isVisitReportLoading2 ? (
                        <div className="spinner"></div>
                      ) : (
                        <ArrowDownIcon color="white" className="filter-icon" />
                      )}
                    </button>
                    <button
                      className="download-excel-button"
                      onClick={handleWasteReport}
                      disabled={isWasteReportLoading}
                    >
                      <p>{isWasteReportLoading ? "İndiriliyor..." : "Poşet Verme/Atık Alma Raporları"}</p>
                      {isWasteReportLoading ? (
                        <div className="spinner"></div>
                      ) : (
                        <ArrowDownIcon color="white" className="filter-icon" />
                      )}
                    </button>
                    <button
                      className="download-excel-button"
                      onClick={handleFullReport}
                      disabled={isAllReportLoading}
                    >
                      <p>{isAllReportLoading ? "İndiriliyor..." : "Diğer Raporlar"}</p>
                      {isAllReportLoading ? (
                        <div className="spinner"></div>
                      ) : (
                        <ArrowDownIcon color="white" className="filter-icon" />
                      )}
                    </button>
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {summaryData?.statistic && (
        <>
          <h2 className="summary-subtitle">Genel Poşet/Atık/Personel Bilgisi</h2>
          <div className="statistics-section">
            <div className="stat-card-container separated-waste-statistics">
              <div className="stat-card">
                <h3>
                  Toplam
                  <br />
                  Dağıtılan Poşet Sayısı
                </h3>
                <p className="stat-card-number">
                  {formatNumber(summaryData.statistic.verilenToplamPoset)}
                </p>
                <p className="stat-card-text">adet</p>
              </div>
              <div className="stat-card green">
                <h3>
                  Toplam
                  <br />
                  Toplanan Atık Sayısı
                </h3>
                <p className="stat-card-number">
                  {formatNumber(summaryData.statistic.toplamAtik)}
                </p>
                <p className="stat-card-text">adet atık</p>
              </div>

                    <div className="stat-card">
                <h3>
                  Toplam
                  <br />
                  Sahadaki Kişi Sayısı
                </h3>
                <p className="stat-card-number">
                  {formatNumber(summaryData.statistic.sahaKisiSayisi)}
                </p>
                <p className="stat-card-text">kişi</p>
              </div>
            </div>
          </div>

         

          <h2 className="summary-subtitle">Genel Ziyaret/İşlem Bilgisi</h2>
          <div className="statistics-section">
            <div className="stat-card-container separated-waste-statistics">
              <div className="stat-card">
                <h3>
                  Toplam
                  <br />
                  İşlem Sayısı
                </h3>
                <p className="stat-card-number">
                  {/* Poşet verme + atık alma işlemlerinin toplamı */}
                  {formatNumber(summaryData.statistic.toplamIslemSayisi ?? 0)}
                </p>
                <p className="stat-card-text">adet</p>
              </div>
              <div className="stat-card green">
                <h3>
                  Toplam
                  <br />
                  Atık Alındı Sayısı
                </h3>
                <p className="stat-card-number">
                  {formatNumber(summaryData.statistic.atikAlindiSayisi ?? 0)}
                </p>
                <p className="stat-card-text">adet</p>
              </div>
              <div className="stat-card">
                <h3>
                  Toplam
                  <br />
                  Ziyaret Edildi Sayısı
                </h3>
                <p className="stat-card-number">
                  {/* "Poşet Dolmamış" dahil tüm ziyaret (blokaj) kayıtları */}
                  {formatNumber(summaryData.statistic.ziyaretEdildiSayisi ?? 0)}
                </p>
                <p className="stat-card-text">ziyaret</p>
              </div>
            </div>
          </div>

          <h2 className="summary-subtitle ">Genel Ayrıştırma Bilgisi</h2>
          <div className="statistics-section">
            <div className="stat-card-container separated-waste-statistics">
              <div className="stat-card">
                <h3>
                  Toplam
                  <br />
                  Alınan Atık
                </h3>
                <p className="stat-card-number">
                  {formatNumber(
                    summaryData.statistic.toplamReddedilenAtik +
                      summaryData.statistic.toplamOnaylananAtik
                  )}
                </p>
                <p className="stat-card-text">adet</p>
              </div>
              <div className="stat-card red">
                <h3>
                  Toplam
                  <br />
                  Reddedilen Atık Sayısı
                </h3>
                <p className="stat-card-number red">
                  {formatNumber(summaryData.statistic.toplamReddedilenAtik)}
                </p>
                <p className="stat-card-text">adet</p>
              </div>
              <div className="stat-card">
                <h3>
                  Toplam
                  <br />
                  Onaylanan Atık Sayısı
                </h3>
                <p className="stat-card-number">
                  {formatNumber(summaryData.statistic.toplamOnaylananAtik)}
                </p>
                <p className="stat-card-text">adet atık</p>
              </div>
            </div>
          </div>

          <div className="card">
          <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Ziyaret Kayıtları</h2>
      <div className="mb-3">
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            value={globalFilter}
            onChange={handleFilterChange}
            placeholder="Arama yap..."
          />
        </span>
      </div>
      <DataTable className="summary-table" loading={loading} filterDisplay="row"  header stripedRows 
        value={filteredData}
        paginator
        rows={rows}
        totalRecords={filteredData.length}
        first={page * rows}
        onPage={handlePageChange}
      >
        <Column sortable field="islemTarihi" header="Tarih" body={row => row.islemTarihi?.split("T")[0].split(" ")[0]} />
        <Column sortable field="islemSaati" header="Saat" />
        <Column sortable field="adres" header="Adres" />
        <Column sortable field="personel" header="Personel" />
        <Column sortable field="islemTuru" header="İşlem Türü" />
        <Column sortable  field="katilmamaSebebi" header="Katılmama Sebebi" />
      </DataTable>
    </div>
        </div>
 
        <style jsx>{`
          span.p-column-title {
            color: white;
          }
            .p-datatable .p-datatable-tbody > tr > td {
                padding: 10px !important;
            }
      `}</style>
  {/* EN ÇOK HANEYE SAHİP İLÇELER */}
  <div className="statistics-bar-chart">
  <h2 className="summary-subtitle">İlçe Bazında Verilen Poşet Sayıları</h2>
<ResponsiveContainer width="100%" height={300}>
  <BarChart
    data={[...topIlceler].sort((a, b) => b.haneSayisi - a.haneSayisi)}
    margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
  >
    <XAxis dataKey="ilce" />
    <YAxis />
    <Tooltip formatter={(value) => formatNumber(value)} />
    <Bar dataKey="haneSayisi" fill="#17a2b8" name="Poşet Sayısı">
      <LabelList dataKey="haneSayisi" position="top" formatter={(value) => formatNumber(value)} />
    </Bar>
  </BarChart>
</ResponsiveContainer>
</div>
{/* EN ÇOK HANENİN OLDUĞU MAHALLELER */}
<div className="statistics-bar-chart">
<h2 className="summary-subtitle">Mahalle Bazında Verilen Poşet Sayıları</h2>
<ResponsiveContainer width="100%" height={300}>
  <BarChart
    data={[...topMahalleler].sort((a, b) => b.haneSayisi - a.haneSayisi)}
    margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
  >
    <XAxis dataKey="neighborhood" />
    <YAxis />
    <Tooltip formatter={(value) => formatNumber(value)} />
    <Bar dataKey="haneSayisi" fill="#6f42c1" name="Poşet Sayısı">
      <LabelList dataKey="haneSayisi" position="top" formatter={(value) => formatNumber(value)} />
    </Bar>
  </BarChart>
</ResponsiveContainer>
</div>
{/* EN ÇOK HANENİN OLDUĞU 10 SOKAK */}
<div className="statistics-bar-chart">
<h2 className="summary-subtitle">Sokak Bazında Poşet Verilen İlk 20 Sokak</h2>
<ResponsiveContainer width="100%" height={500}>
  <BarChart   margin={{ top: 20, right: 30, left: 0, bottom: 180 }}  // bottom değerini artırdık

    data={
      summaryData?.sokak
        ?.slice() // kopyasını al
        .sort((a, b) => b.haneSayisi - a.haneSayisi) // sırala
        .slice(0, 20) // ilk 10'u al
    }
    
  >
    <XAxis dataKey="street"  
  angle={-45}
  textAnchor="end"
  interval={0}
  height={70}            // XAxis yüksekliğini artırıyoruz
  dy={10}    />
    <YAxis />
    <Tooltip formatter={(value) => formatNumber(value)} />
    <Bar dataKey="haneSayisi" fill="#fd7e14" name="Poşet Sayısı">
      <LabelList dataKey="haneSayisi" position="top" formatter={(value) => formatNumber(value)} />
    </Bar>
  </BarChart>
</ResponsiveContainer>
</div>

        </>
      )}
    </div>
  );
};

export default Summary;
